(function() {
    'use strict';

    angular.module('itxApp.preCommon')
        .factory('CommonServices', commonServices);

        commonServices.$inject = ['$q'];

    function commonServices ($q) {

        var _this = this;

        _this.DEFAULT_USER = {
            email: null,
            is360: false,
            showPrivateSale: 0
        };

        return {
            // mdUtils
            isWebapp: _isWebapp,
            isExplorer: inditex.isExplorer,
            // ItxConfigurationSvc
            isDebugActive: _isDebugActive,
            getApiPath: _getApiPath,
            // crmService
            is360: _is360,
            //NewsletterSvc
            getNewsletterStatus: _getNewsletterStatus,
            getCurrentUser: _getCurrentUser,
            isVip: isVip,
            isCookieGroupAllowed: _isCookieGroupAllowed,
            privateSalesEnabled: _privateSalesEnabled,
            getEnvironment: _getEnvironment,
            isMicrositeOrLookBook: _isMicrositeOrLookBook
        };

        function _isCookieGroupAllowed(group){
            if(!group || !inditex.cookieConsent || window.OneTrust === undefined) return false;

            if(!inditex.cookieConsent.isInitialised()) inditex.cookieConsent.init();
            
            const cookieGroupAllowed = inditex.cookieConsent.isGroupAllowed(group);

            return cookieGroupAllowed;
        };

        function _privateSalesEnabled() {
            return (inditex && inditex.iUserJSON && inditex.iUserJSON.showPrivateSale === 1) || false;
        }

        function isVip(iUserJSON=undefined, isSuscribed=undefined){
            var deferred = $q.defer();
            if(_isWebapp()){
                // deferred.resolve(_isAppVip()); //quitamos esto porque en la url de la push no pondran el parametro
                deferred.resolve(true);
            } else {
                if(!_isCountryFeel() && isSuscribed !== undefined && isSuscribed !== null   ){ 
                    deferred.resolve(isSuscribed);
                } else {
                    if(!iUserJSON){
                        if(inditex){
                            iUserJSON = inditex.iUserJSON;
                        }
                    }

                    if(!iUserJSON){
                        deferred.resolve(false);
                    } else {
                       
                        if (_isCountryFeel()) {
                            deferred.resolve(_is360(iUserJSON));
                        } else {
                            const isDebugActive = _isDebugActive();
                            if(isDebugActive){
                                const localVip = inditex.getLocalStorage('USER_VIP');
                                if(localVip !== undefined && localVip !== null){
                                    const debugVip = localVip === 'true' ? true : false;
                                    deferred.resolve(debugVip);
                                } else {
                                    deferred.resolve(false);
                                }
                            } else {
                                _getNewsletterStatus(iUserJSON.email)
                                .then(function(alreadySuscribed){
                                    deferred.resolve(alreadySuscribed);
                                }).catch(function (err){
                                    deferred.resolve(false);
                                });
                            }
                        }
                    }
                }
            }

            return deferred.promise;
        }

        function _isWebapp() {
            return String(navigator.userAgent).toLowerCase().indexOf('massimodutti_ecom') > -1;
        }
        
        function _isCountryFeel() {
            const storeId = inditex.iStoreId;
            const storeES = 34009450;
            const storeIC = 34009463;
            const storePT = 34009460;
            return storeId === storeES || storeId === storeIC || storeId === storePT;
        }

        function _isDebugActive() {
            var debugActive = (inditex.getSessionStorage('DebugActive')  ? true : false);
            return debugActive;
        }

        function _isAppVip() {
            const storeId = inditex.iStoreId;
            const storeES = 34009450;
            const storeIC = 34009463;
            if (storeId !== storeES && storeId !== storeIC) {
                return true;
            } else {
                const params = inditex.iUrlJSON.params;
                if(params){
                    const paramDisableRegister = params.disableRegister;

                    const appVip = paramDisableRegister === 1 || paramDisableRegister === "true";
                    return appVip;
                }

                return false;
            }
        }

        function _is360(iUserJSON=undefined){
            if(!iUserJSON){
                if(inditex){
                    iUserJSON = inditex.iUserJSON;
                }
            }
            
            const localStorage360 = inditex.getLocalStorage('USER_360');

            if(localStorage360 !== undefined && localStorage360 !== null){
                const debug360 = localStorage360 === 'true' ? true : false;
                return debug360;
            } else {
                const userJson360 = (iUserJSON && iUserJSON.is360) || false; //se añade el || false para que siempre devuelva un boolean
                return userJson360;
            }
        }

        function _getEnvironment() {
            var environment;
            switch(window.location.hostname){
                case 'localhost':
                    environment = 'DEVELOPMENT';
                    break;
                case 'int-massimoduttiphr.inditex.com':
                    environment = 'DEVELOPMENT';
                    break;
                case 'axpreprueccwpslb1-massimodutti.central.inditex.grp':
                    environment = 'PREPRU';
                    break;
                case 'dyn-massimoduttiphr.inditex.com':
                    environment = 'PRUSTG';
                    break;
                case 'axprelteccvshlb1-massimodutti.central.inditex.grp':
                    environment = 'PRELT';
                    break;
                case 'axpreprustgeccwpslb1-massimodutti.central.inditex.grp':
                    environment = 'PRUSTG';
                    break;
                case 'axinstgeccwps1-massimodutti.central.inditex.grp':
                    environment = 'STAGE';
                    break;
                case 'des-mdfrontw-pro-webecom.md.apps.axdesecocp1.ecommerce.inditex.grp':
                    environment = 'PAAS_DES_DES_PRO';
                    break;
                default:
                    environment = 'PRO';
                    break;
            }
            return environment;
        }


        function _getApiPath (){
            return 'https://'+inditex.iProxyHostStandard + '/itxrest/2';
        }

        function _getNewsletterStatus (email){
            var deferred = $q.defer();

            if(!email){
                deferred.resolve(false);
            } else {
                var request = new XMLHttpRequest();
                const url = 'https://' + inditex.iProxyHostStandard + '/itxrest/2/user/store/' + inditex.iStoreId + '/newsletter?languageId=' + inditex.iLangId + '&email=' + email + '&appId=' + inditex.iAppId;
                request.open('GET', url, true);
                request.setRequestHeader('Content-Type', 'application/json');

                request.onload = function() {
                    if (request.status >= 200 && request.status < 400) {
                        var newsletter = JSON.parse(request.response).newsletter;
                        const isSuscribred = newsletter !== null && newsletter !== undefined && newsletter.length > 0; //en este objeto llegan las opciones a las que esta suscrito separado con #.
                        deferred.resolve(isSuscribred);
                    } else {
                        deferred.resolve(false);
                    }
                };

                request.onerror = function() {
                    deferred.resolve(false);
                };

                request.send();
            }

            return deferred.promise;
        }
        
        function _getCurrentUser(){
            var deferred = $q.defer();

            var request = new XMLHttpRequest();

            const storeId = inditex.iStoreId;
            const langId = inditex.iLangId;
            const appId = inditex.iAppId;
            const ts = inditex.iRegistryTs;

            if(!storeId || !langId || !appId){
                return deferred.resolve(_this.DEFAULT_USER);
            }
            
            let url = `https://${inditex.iProxyHostStandard}/itxrest/2/user/store/${storeId}/current-user?languageId=${langId}&appId=${appId}`;
            if(ts){
                url = `${url}&ts=${ts}`;
            }

            request.open('GET', url, true);
            request.setRequestHeader('Content-Type', 'application/json');

            request.onload = function() {
                if (request.status >= 200 && request.status < 400) {
                    deferred.resolve(JSON.parse(request.response));
                } else {
                    deferred.resolve(_this.DEFAULT_USER);
                }
            };

            request.onerror = function() {
                deferred.resolve(_this.DEFAULT_USER);
            };

            request.send();

            return deferred.promise;

        }

        /**
         * Función para saber si la página actual es un microsite o un lookbok
         */
        function _isMicrositeOrLookBook() {
            if (inditex && inditex.iCategoryJSON && (inditex.iCategoryJSON.type === '44' || inditex.iCategoryJSON.type === '1')) {
                return true;
            }

            return false;
        }

    }

})();